import { useTranslation } from "react-i18next";
import { Block, Box } from "../../../styles/basicStyles";
import { BlogPost } from "../../../models/blog";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import { useRouter } from "next/router";
import { CardWrapper } from "./styles";
import Typography from "../../../components/typography";
import Card from "../../../components/views/card";

interface RelatedBlogPosts {
  blogPosts: BlogPost[];
  hasCaseStudies: boolean;
}

const RelatedBlogPosts: FC<RelatedBlogPosts> = ({ blogPosts, hasCaseStudies }) => {
  const { t, i18n: { language } } = useTranslation();
  const router = useRouter();

  return (
    <Box fDirection="column" mt={hasCaseStudies ? 0 : 3.25} mb={3.25}>
      <Typography
        fSize={{ md: 1.875, xxs: 1.75 }}
        lHeight={{ md: 2.25, xxs: 2.063 }}
        fWeight={700}
        color={colors.black}
        pb={1.75}
      >
        {t("RELATED_BLOG_POSTS")}
      </Typography>
      <CardWrapper
        display='flex'
        margin={{ xs: '0 -1.125rem', xxs: 0 }}
      >
        {
          blogPosts.map((post, index) =>
            <Block 
              key={index}
              w={{ md: "33.333%", xs: "50%", xxs: "100%" }} 
              padding={{ xs: '0 1.125rem', xxs: 0 }}
              mb={2.25}
            >
              <Card 
                imagePath={post.image?.url}
                title={post.category?.name && post.category.name[language]}
                subtitle={post.title && post.title[language]}
                author={post.author?.name}
                date={post.date}
                onClick={() => router.push(`/blog/${post.url}`)}
              />
            </Block>
          )
        }
      </CardWrapper>
    </Box>
  );
};

export default RelatedBlogPosts;
